import React from 'react'
import { groupBy } from 'lodash'
import { useParams } from 'react-router'
import { Card, Table, Tag } from 'antd'
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons'
import { v4 } from 'uuid'
import { useDocumentTitle } from '../../../../hooks/useDocumentTitle'
import assignmentSelectors from '../../../../store/selectors/assignment.selectors'
import { useSelector } from 'react-redux'
import { useFetchLayersGroupReportQuery } from '../../../../store/apis/group.api'

const SummaryTableColumns = [
    {
        title: 'Group',
        dataIndex: 'groupName',
        key: 'groupName',
        render: output => <div className='text-color' dangerouslySetInnerHTML={{ __html: output }} />,
    },
    {
        title: 'Feedback',
        key: 'hasFeedback',
        render: item => {
            if (item.hasFeedback === true) {
                return (
                    <Tag icon={<CheckCircleOutlined />} color='success'>
                        SET
                    </Tag>
                )
            } else if (item.hasFeedback === false) {
                return (
                    <Tag icon={<CloseCircleOutlined />} color='error'>
                        NOT SET
                    </Tag>
                )
            }
        },
    },
    {
        title: 'Grade',
        key: 'hasGrade',
        render: item => {
            if (item.hasGrade === true) {
                return (
                    <Tag icon={<CheckCircleOutlined />} color='success'>
                        SET
                    </Tag>
                )
            } else if (item.hasGrade === false) {
                return (
                    <Tag icon={<CloseCircleOutlined />} color='error'>
                        NOT SET
                    </Tag>
                )
            }
        },
    },
    {
        title: 'Submissions Number',
        dataIndex: 'submissionsNumber',
        key: 'submissionsNumber',
    },
]

const SummaryReportSection = () => {
    const assignmentName = useSelector(assignmentSelectors.name)
    useDocumentTitle(`${assignmentName || ''} Summary`)

    const { token } = useParams()
    const { data: layersGroupReport, isFetching: isFetchingLayersGroupReport } = useFetchLayersGroupReportQuery({
        token,
    })

    const groupedReportData = groupBy(layersGroupReport, layerGroup => layerGroup.layer.name)
    const formattedReportData = []
    Object.keys(groupedReportData).map(key => {
        if (key) {
            formattedReportData.push({
                key: v4(),
                groupName: `<b>${key} - ${groupedReportData[key].length} groups</b>`,
                isHeader: true,
                className: 'summary-report-section__header-row',
            })
        }
        groupedReportData[key].map(layerGroup => {
            formattedReportData.push({
                key: v4(),
                groupName: `${layerGroup.group.name}`,
                hasFeedback: Boolean(layerGroup.group.feedback),
                hasGrade: Boolean(layerGroup.group.grade),
                submissionsNumber: layerGroup.group.numberOfSubmissions,
                isHeader: false,
            })
        })
    })

    return (
        <div className='summary-report-section'>
            <Card title='Summary Report'>
                <Table
                    columns={SummaryTableColumns}
                    rowClassName={record => record.className}
                    dataSource={formattedReportData}
                    pagination={false}
                    loading={isFetchingLayersGroupReport}
                    scroll={{ x: true }}
                />
            </Card>
        </div>
    )
}

export default SummaryReportSection
